import { render } from "./Work.vue?vue&type=template&id=d57ea5b4&scoped=true&ts=true"
import script from "./Work.vue?vue&type=script&lang=ts"
export * from "./Work.vue?vue&type=script&lang=ts"

import "@/components/SelectedWork/Work/style.scss?vue&type=style&index=0&id=d57ea5b4&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d57ea5b4"]])

export default __exports__